<template>
  <div role="tabpanel" id="tabs-complaint">
    <div class="addInHiddenInView">
      <div v-if="checkCredential('complaintAdd') && !bookingIsDeleted" class="tabs_button">
         <span data-toggle="modal"
                    data-target="#add-issue"
                    style="cursor: pointer;">
                  <span class="float-right">
                      <a href="javascript:;">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                               xmlns="http://www.w3.org/2000/svg"> <path
                              d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                              fill="#03A9F4"/> </svg>
                      </a>
                  </span>
                  <span class="select-services-dropdown-add-label float-right">Add</span>
              </span>
      </div>
    </div>
    <div id="complaint-info">
      <div class="tab_padding float_none">
        <div v-if="bookingComplaints.length">
          <div class="row m-0" v-if="!isMobile">
            <div class="col-md-2">
              <div class="col-md-12">
                <b class="title">Created</b>
              </div>
            </div>
            <div class="col-md-2">
              <div class="col-md-12">
                <b class="title">ID</b>
              </div>
            </div>
            <div class="col-md-2">
              <div class="col-md-12">
                <b class="title">Issue type</b>
              </div>
            </div>
            <div class="col-md-2">
              <div class="col-md-12">
                <b class="title">Assignee</b>
              </div>
            </div>
            <div class="col-md-2">
              <div class="col-md-12">
                <b class="title">Reported by</b>
              </div>
            </div>
            <div class="col-md-2">
              <div class="col-md-12">
                <b class="title">Status</b>
              </div>
            </div>
          </div>

          <div class="row m-0 columns-design" v-for="complaint in bookingComplaints" :key="complaint.complaint_id">
            <div class="col-md-2 col-xs-12" data-toggle="modal"
                 :data-target="`#issue-popup${complaint.complaint_id}issueTab`">
              <div class="col-xs-12 m-bottom-0" v-if="isMobile">
                <div class="col-xs-6 p-left-0 m-bottom-0">
                  <b class="title">Created</b>
                </div>
                <div class="col-xs-5 p-right-0 m-bottom-0">
                  <div class="content-font-style float-right">
                    <div class="clearfix" v-if="isMobile"></div>
                    <div class="btn-group pair_btn_new_uniq mobile-position">
                      <button data-toggle="dropdown" data-too="tooltip" data-placement="bottom"
                              aria-haspopup="true" aria-expanded="false"
                              class="btn btn-default dropdown-toggle create-btn FontSize">
                        <i class="fa fa-ellipsis-v " style="color:rgba(138, 138, 138,1);font-size: 18px;"></i>
                      </button>
                      <div class="clearfix" v-if="isMobile"></div>
                      <ul class="dropdown-menu pair_of_all_li w_und_767 dropdown-menu-position" id="pair_of_all_li">
                        <li>
                          <a :href="`#delete-issue-confirmation${complaint.complaint_id}`" data-toggle="modal">
                            <span><i class="fa fa-trash"></i> Delete</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-xs-1 p-right-0 m-bottom-0">
                  <div class="content-font-style float-right">
                    <div class="float-right">
                      <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.99984 0L0.589844 1.41L5.16984 6L0.589844 10.59L1.99984 12L7.99984 6L1.99984 0Z"
                              fill="black"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-xs-12 content-font-style">
                {{ formatDate(complaint.created) }}
              </div>
            </div>
            <div class="col-md-2 col-xs-12" data-toggle="modal"
                 :data-target="`#issue-popup${complaint.complaint_id}issueTab`">
              <div class="col-md-12 col-xs-12" v-if="isMobile">
                <b class="title">ID</b>
              </div>
              <div class="col-md-12 content-font-style">
                {{ complaint.complaint_num }}
              </div>
            </div>
            <div class="col-md-2 col-xs-12" data-toggle="modal"
                 :data-target="`#issue-popup${complaint.complaint_id}issueTab`">
              <div class="col-md-12 col-xs-12" v-if="isMobile">
                <b class="title">Issue type</b>
              </div>
              <div class="col-md-12 content-font-style">
                <span v-if="complaint.complaint_type_name">{{ complaint.complaint_type_name }}</span>
                <span v-else>---</span>
              </div>
            </div>
            <div class="col-md-2 col-xs-12" data-toggle="modal"
                 :data-target="`#issue-popup${complaint.complaint_id}issueTab`">
              <div class="col-md-12 col-xs-12" v-if="isMobile">
                <b class="title">Assignee</b>
              </div>
              <div class="col-md-12 content-font-style">
                <img :src="getAvatarImage(complaint.assignee.avatar_img)" class="img-circle" alt="" width="30">
                {{ complaint.assignee.first_name }} {{ complaint.assignee.last_name}}
              </div>
            </div>
            <div class="col-md-2 col-xs-12" data-toggle="modal"
                 :data-target="`#issue-popup${complaint.complaint_id}issueTab`">
              <div class="col-md-12 col-xs-12" v-if="isMobile">
                <b class="title">Reported by</b>
              </div>
              <div class="col-md-12 content-font-style">
                <img :src="getAvatarImage(complaint.user_img)" class="img-circle" alt="" width="30">
                {{ complaint.username }}
              </div>
            </div>
            <div class="col-md-2 col-xs-12" data-toggle="modal"
                 :data-target="`#issue-popup${complaint.complaint_id}issueTab`">
              <div class="col-md-12 col-xs-12" v-if="isMobile">
                <b class="title">Status</b>
              </div>
              <div class="col-md-8 content-font-style">
                        <span
                            class="status-label labels-font font-family-Roboto m-right-5 position-status-invoice-modal cursor-pointer"
                            :style="'background-color:' + complaint.complaint_status_row.color+' !important;color:#FFFFFF !important'">
                            {{ (complaint.complaint_status_row || {}).name }}
                        </span>
              </div>
              <div class="col-md-4 content-font-style p-right-0">

                <div class="btn-group pair_btn_new_uniq">
                  <button data-toggle="dropdown" data-too="tooltip" data-placement="bottom"
                          aria-haspopup="true" aria-expanded="false"
                          class="btn btn-default dropdown-toggle create-btn FontSize">
                    <i class="fa fa-ellipsis-v " style="color:rgba(138, 138, 138,1);font-size: 18px;"></i>
                  </button>
                  <ul class="dropdown-menu pair_of_all_li w_und_767 dropdown-menu-position" id="pair_of_all_li">
                    <li>
                      <a :href="`#delete-issue-confirmation${complaint.complaint_id}`" data-toggle="modal">
                        <span><i class="fa fa-trash"></i> Delete</span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="float-right position-relative top-2" data-toggle="modal" :data-target="`#issue-popup${complaint.complaint_id}issueTab`">
                  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.99984 0L0.589844 1.41L5.16984 6L0.589844 10.59L1.99984 12L7.99984 6L1.99984 0Z"
                          fill="black"/>
                  </svg>
                </div>
              </div>
            </div>
            <view-issue-popup
                              :complaint-id="complaint.complaint_id"
                              tabName="issueTab"
                              :loggedUser="loggedUser"
                              :s3-path="s3Path"
            ></view-issue-popup>
          </div>
        </div>
        <div v-else class="inquiry-no-result">
         <br/>
          <h3 class="font-bold"> <span class="fa fa-ban"></span> No Issues Reported
          </h3>
          <p class="font-14 w-80">
             No issues have been reported for this customer yet.
            Any concerns or problems linked to quotes and bookings
            related to this customer will appear here. Issues must be
            logged directly from the booking or quote, and they will be
            displayed here for your reference.

          </p>
        </div>
      </div>
    </div>

    <add-issue-popup :logged-user="loggedUser" :booking-id="bookingId??itemId" :s3-path="s3Path"></add-issue-popup>

  </div>
</template>
<script>
import {deleteComplaint, getSingleTabData} from "@/modules/Booking/api/BookingViewTabs";
import moment from "moment-timezone";
import ConfirmationPopup from "@/modules/common/components/ConfirmationPopup.vue";
import {EventBus} from "@/events/event-bus";
import ViewIssuePopup from "./ViewIssuePopup.vue";
import AddIssuePopup from "./AddIssuePopup.vue";

export default {
  name: "IssuesTab",
  components: {AddIssuePopup, ViewIssuePopup, ConfirmationPopup},
  props: {

    itemType: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    credentials: {
      type: Object,
      default: () => ({}) // Default value is an empty object
    },
    loggedUser: {
      type: Object,
      default: () => ({}) // Default value is an empty object
    },
    s3Path: null,
    bookingId: null,
    view: 'booking',
    showViewIssuesPopup: 0,
  },
  data() {
    return {
      bookingIsDeleted: false,
      bookingComplaints: [],
      dateTimeObj: null
    }
  },
  computed: {
    isMobile() {
      return this.getWidth() <= 768;
    },
  },
  methods: {
    getWidth() {
      let xWidth = null;
      if (window.screen != null)
        xWidth = window.screen.availWidth;

      if (window.innerWidth != null)
        xWidth = window.innerWidth;

      if (document.body != null)
        xWidth = document.body.clientWidth;

      return xWidth;
    },
    checkCredential(permission) {
      if (this.credentials[permission]) {
        return true
      } else {
        return false
      }
    },
    formatDate(created) {
      const dateFormat = this.convertToMomentFormat(this.dateTimeObj.date_format);
      return moment(created * 1000).tz(this.dateTimeObj.time_zone).format(dateFormat);
    },
    trimComment(comment) {
      return comment.length > 50 ? `${comment.substring(0, 50)}...` : comment;
    },
    show_comment_listener(comment) {
      return this.trimComment(comment);
    },
    showAddIssuePopup() {
      let AddPopUpUrl = `/complaint/add/${this.itemId}?fromVue=1`
      window.popupi('Add Issue', AddPopUpUrl);
    },
    showEditIssuePopup(complaintId) {
      let editPopUpUrl = `/complaint/edit/${complaintId}?fromVue=1`
      window.popupi('Edit Issue', editPopUpUrl);
    },
    fetchData() {
      let params = {
        type: "complaint",
        booking_id: this.bookingId??this.itemId,
        fromVuejs: true
      }
      getSingleTabData(params).then((response) => {
        this.bookingComplaints = response.data.bookingComplaints;
        this.bookingId = response.data.bookingId;
        this.dateTimeObj = response.data.dateTimeObj;
        this.$emit('issuesCountUpdated', this.bookingComplaints.length);
      })
    },
    convertToMomentFormat(format) {
      const mapping = {
        'EEEE, d MMMM y': 'dddd, D MMMM YYYY',
        'd MMMM y': 'D MMMM YYYY',
        'd MMM y': 'D MMM YYYY',
        'dd/mm/yyyy': 'DD/MM/YYYY'
        // Add any additional mappings as needed
      };
      return mapping[format] || "Format not recognized";
    },
    initiateEventListeners() {
      EventBus.$on('newComplaintAdded', () => {
        this.fetchData();
      })
      EventBus.$on('editComplaint', () => {
        this.fetchData();
      })
      EventBus.$on('complaintDeleted', (complaintId) => {
        this.bookingComplaints = this.bookingComplaints.filter(complaint => complaint.complaint_id !== complaintId);
        this.$emit('issuesCountUpdated', this.bookingComplaints.length);
      })
    },
    getAvatarImage(avatar) {
      return 'data:image/png;base64,' + avatar;
    },
  },
  mounted() {

    this.fetchData();
    this.initiateEventListeners();

    this.$nextTick(function () {
      EventBus.$on('showCommentWhenChange', value => {
        this.bookingComplaints.forEach(item => {

          if (item.complaint_id == value.complaintId) {
            item.comment = value.commentValue;
          }
        });

      });
    });
  },
}
</script>
<style scoped>
.tabs_button {
  background-color: #FFFFFF !important;
  padding-bottom: 25px !important;
}

#tabs-complaint {
  background-color: #F3F3F4 !important;
}

.title {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: #62707C;
}

.content-font-style {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #2E4051;
}

.m-0 {
  margin: 0px;
}

.columns-design {
  background: #fff;
  padding: 20px 0;
  margin: 8px 0 0 0;
  border-radius: 12px;
}

.status-label {
  color: #FFFFFF !important;
  border-radius: 100px !important;
  padding: 3px 8px 4px 8px !important;
}

.labels-font {
  font-size: 14px;
  font-weight: 700;
  color: #2E4051;
}

.font-family-Roboto {
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: #2E4051;
}

.dropdown-menu-position {
  right: 0px !important;
  left: auto !important;
  min-width: 200px !important;
}

.pair_btn_new_uniq .create-btn {
  border: none !important;
  width: 25px !important;
  height: 25px !important;
}
.position-relative{
  position: relative;
}
.top-2{
  top: 2px;
}

@media (max-width: 991px) {
  .mobile-position {
    position: relative;
    right: 8px;
  }

  .m-bottom-0 {
    margin-bottom: 0px !important;
  }
}
#page-wrapper{
  min-height: fit-content !important;
}
:deep(#page-wrapper){
  min-height: fit-content !important;
}

.font-14{
  font-size:14px
}
.w-80{
  width:80%;
  margin: auto;
}
</style>